import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';

export type EmployeeCoefficientT = {
  defaultCoefficient: number,
  vacationSettingId: number,
  userId: number
}

export type UpdateEmployeeCoefficientDto = Pick<EmployeeCoefficientT, 'userId' | 'vacationSettingId'>
export type UpdateEmployeeBody = {
  employeesCoefficientDtoList: UpdateEmployeeCoefficientDto[],
  name: string,
  order: 'ASC' | 'DESC',
  page: number,
  perPage: number
}

export interface SavedSettingsType {
  name: string,
  employeesRequest: {
    order: 'ASC' | 'DESC' | null,
    page: number,
    perPage: number
  }
}

export type SettingEmployeeT =  {
  availableDays: number,
  firstName: string,
  lastUpdatedAt: Date,
  hireDate: Date,
  lastName: string,
  userId: number,
  vacationSettingId: number,
}

export type SettingsCoefficientType = {defaultCoefficient: number, id:number}

export type SettingsEmployeeListT = {
  hasHrChangedWorkExperience: boolean,
  list: SettingEmployeeT[],
  onPage: 0,
  lastUpdatedAt?: Date,
  page: 0,
  perPage: 0,
  total: 0
}

class Settings {
  listCoefficients: SettingsCoefficientType[] = [];
  isFetched = false;
  currentList:SettingsEmployeeListT = {
    hasHrChangedWorkExperience: true,
    list: [],
    onPage: 0,
    page: 0,
    perPage: 0,
    total: 0
  };
  isSavedStateFetched = false;
  savedState: SavedSettingsType = {
    name: '',
    employeesRequest: {
      order: null,
      page: 1,
      perPage: 10
    }
  };

  constructor() {
    makeAutoObservable(this);
  }

  fetchCoefficients = async () => {
    this.listCoefficients = await apiConfig.settingsService.listCoefficients();
  };

  submitList = async (dto: UpdateEmployeeBody) => {
    const res = await apiConfig.settingsService.updateEmployeeList(dto);
    this.currentList.hasHrChangedWorkExperience = true;
    this.currentList = res;
  };
  getCurrentList = async (page: number, perPage: number, employeeName: string, order: 'ASC' | 'DESC') =>{
    this.isFetched = false;
    try {
      this.currentList = await apiConfig.settingsService.employeesList(page, perPage, employeeName, order);
      this.isFetched = true;
    } catch (e) {
      this.isFetched = false;
    }
  };
  updateConditionsForList = (newCond: number) => {
    this.currentList.list = this.currentList.list.map(item=> ({...item, vacationSettingId: newCond}));
  };
  updateCoefficients = (newCoef: Partial<EmployeeCoefficientT>) => {
    this.currentList.list =
      this.currentList.list.map(item=> item.userId === newCoef.userId
        ? ({...item, ...newCoef}) : ( {...item}));
  };
  fetchSavedVacationSettings = async () => {
    try {
      this.savedState = await apiConfig.settingsService.getSavedVacationSettings();
      this.isSavedStateFetched = true;
    } catch (e) {
      this.isSavedStateFetched = true;
    }
  };
  updateSavedVacationSettings = async(settings: SavedSettingsType) => {
    try {
      this.savedState = settings;
      await apiConfig.settingsService.updateSavedVacationSettings(settings);
    }
    catch (e) {
      this.savedState = settings;
    }
  };
  updateSavedName = (value: string) => {
    this.updateSavedVacationSettings({name: value, employeesRequest: {...this.savedState.employeesRequest}});
  };
  updateSavedOrder = (value: 'ASC' | 'DESC' | null) => {
    this.updateSavedVacationSettings({name: this.savedState.name,
      employeesRequest: {...this.savedState.employeesRequest, order: value}
    });
  };
  updateSavedPage = (value: number) => {
    this.updateSavedVacationSettings({name: this.savedState.name,
      employeesRequest: {...this.savedState.employeesRequest, page: value}
    });
  };
  updateSavedPaginateParams = (perPage: number, page: number) => {
    this.updateSavedVacationSettings({name: this.savedState.name,
      employeesRequest: {...this.savedState.employeesRequest, page: page, perPage: perPage}
    });
  };
}

const SettingsStore = new Settings();

export default SettingsStore;